<template>
	<div class="flex space-x-3.5 md:space-x-6 items-center p-2 md:p-6">
		<div class="w-32 h-32 md:w-64 md:h-64 shrink-0 rounded-md bg-cover bg-center" :style="'background-image: url(' + props.episode.image + ')'">
		</div>
		<div class="flex-1">
			<div class="flex justify-between pt-1">
				<div class="">
					<div class="text-sm md:text-lg text-gray-700 line-clamp-1">{{ props.episode.podcast.title }}</div>
					<div class="font-bold text-lg md:text-2xl line-clamp-1">{{ props.episode.title }}</div>
				</div>
				<div class="shrink-0">
					<a :href="route('marketing.home')" class="w-6 h-6 bg-gray-400 cursor-pointer hover:bg-regal-blue-900 rounded-md text-white flex items-center justify-center text-xs font-bold">
						P
					</a>
				</div>
			</div>
			<div class="">
				<AudioPlayer :episode="props.episode" @ping="handleProgress"/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, defineProps } from 'vue'
import axios from 'axios'
import AudioPlayer from '@/Shared/AudioPlayer'

const props = defineProps(['episode'])

const handleProgress = (secArray) => {
    axios.patch(route('episodes.track.playback', props.episode.uuid), {
        ticks: secArray
    }).then(res => {
    })
}
</script>